/**
 * F6. Уличная музыка: ритм на 10 секунд, 8 ударов. Деньги и счастье —
 * независимо от точности (написано сразу), точность только для «толпы».
 */
import { t } from '@life/i18n';
import { BUSKING_HAPPINESS, type BuskingInput, type BuskingState } from '@life/minigames';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';
import { Tap } from './ui/Tap';

export function Busking({ state, onInput }: MinigameScreenProps<BuskingInput, BuskingState>) {
  return (
    <>
      <p class="hint">
        {t('ui.minigame.busking.rules', { beats: state.beats.length, s: state.durationMs / 1000, sum: money(state.amount), h: BUSKING_HAPPINESS })}
      </p>
      <Tap beats={state.beats} durationMs={state.durationMs} onDone={(taps) => onInput({ taps })} />
    </>
  );
}
